import Row from 'components/Common/Row';
import Inputs from 'components/Inputs';
import Typography from 'kingpin/atoms/Typography';
import FormInput from 'kingpin/forms/FormInput';
import React, { useContext } from 'react';
import { FindAndReplaceContext } from './FindAndReplace';
import Alert from '../../../../../kingpin/Alert';

const FindAndReplaceSelector = () => {
  const {
    findMetricId,
    setFindMetricId,
    replaceMetricId,
    setReplaceMetricId,
    isArchiveUnusedMetricSelected,
    setIsArchiveUnusedMetricSelected,
  } = useContext(FindAndReplaceContext);

  return (
    <>
      <Alert
        type={'Info'}
        title={'Select metrics'}
        body={"Select a 'Find' metric and 'Replace' metric. "}
      ></Alert>
      <FormInput label="Find">
        <Inputs.MetricPicker
          metricId={findMetricId}
          testIdPrefix={'find'}
          noSpecials={true}
          setMetricId={setFindMetricId}
        ></Inputs.MetricPicker>
      </FormInput>
      <FormInput label="Replace with">
        <Inputs.MetricPicker
          noSpecials={true}
          testIdPrefix={'replace'}
          metricId={replaceMetricId}
          setMetricId={setReplaceMetricId}
        ></Inputs.MetricPicker>
      </FormInput>
      <Row centerAlign style={{ marginTop: 4 }}>
        <Typography.Body type="Body 13">
          Archive 'Find' metric if usage is 0
        </Typography.Body>
        <span style={{ marginRight: 10 }}></span>
        <Inputs.Checkbox
          isChecked={isArchiveUnusedMetricSelected}
          onToggled={setIsArchiveUnusedMetricSelected}
          testId={'archive-unused-metric-checkbox'}
        />
      </Row>
    </>
  );
};

export default FindAndReplaceSelector;
